import type { TypedWrappedFieldProps, WrappedFieldProps } from "redux-form";

import { Divider, Typography } from "@braintrust/braintrust-ui-components";
import { FieldSectionPanelWithImportance } from "@js/apps/jobs/forms/fields";
import { getError, shouldDisplayError } from "@js/forms/utils";

import { AmountAndPaymentTypeField } from "../../fields";
import { useCreateOrEditOfferMeta } from "../../hooks/create-or-edit-offer-meta";

type PayDetailsSectionProps = Record<string, WrappedFieldProps>;

export const FreelancerPayDetailsSection = (props: PayDetailsSectionProps) => {
  const { payment_amount, payment_type } = props;

  const displayError = shouldDisplayError([payment_amount, payment_type]);

  return (
    <FieldSectionPanelWithImportance
      title="💸 Pay details"
      fieldImportance="required"
      isError={displayError}
    >
      <Divider color="beige" sx={{ my: 2 }} />
      <PayRate payment_amount={payment_amount} payment_type={payment_type} />
    </FieldSectionPanelWithImportance>
  );
};

export const DirectHirePayDetailsSection = (props: PayDetailsSectionProps) => {
  const { payment_amount, payment_type } = props;

  const displayError = shouldDisplayError([payment_amount, payment_type]);

  return (
    <FieldSectionPanelWithImportance
      title="💸 Pay details"
      fieldImportance="required"
      isError={displayError}
    >
      <Divider color="beige" sx={{ my: 2 }} />
      <PayRate payment_amount={payment_amount} payment_type={payment_type} />
    </FieldSectionPanelWithImportance>
  );
};

export const GrantPayDetailsSection = (props: PayDetailsSectionProps) => {
  const { payment_amount, payment_type } = props;

  const displayError = shouldDisplayError([payment_amount]);

  return (
    <FieldSectionPanelWithImportance
      title="💸 Pay details"
      fieldImportance="required"
      isError={displayError}
    >
      <Divider color="beige" sx={{ my: 2 }} />
      <PayRate payment_amount={payment_amount} payment_type={payment_type} />
    </FieldSectionPanelWithImportance>
  );
};

const PayRate = ({
  payment_amount,
  payment_type,
}: {
  payment_amount: TypedWrappedFieldProps<string>;
  payment_type: TypedWrappedFieldProps<EnumType<typeof ENUMS.JobPaymentType>>;
}) => {
  const offerMeta = useCreateOrEditOfferMeta();

  return (
    <>
      <Typography
        component="p"
        sx={{
          mb: 2.25,
          overflowWrap: "anywhere",
        }}
      >
        What pay rate are you offering {offerMeta?.talent_name}?
      </Typography>
      {shouldDisplayError(payment_amount) && (
        <Typography
          component="p"
          variant="paragraph"
          error
          sx={{ mb: 2, mt: -2 }}
        >
          {getError(payment_amount)}
        </Typography>
      )}
      <AmountAndPaymentTypeField
        payment_amount={payment_amount}
        payment_type={payment_type}
      />
    </>
  );
};
